import { Button, CardBody, Col, Row } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import { useState } from "react";
export const ProvisingAttributesDetails = ({ startDate, selectedOffer, setFormData, formData }) => {
    if (!selectedOffer?.provisioningAttributes || selectedOffer?.provisioningAttributes.length === 0) {
        return null;
    }
    const [provisioningAttributes, setProvisioningAttributes] = useState(selectedOffer?.provisioningAttributes);

    const handleValueChange = (index, value) => {
        const updatedAttributes = [...provisioningAttributes];
        updatedAttributes[index].value = value;
        setProvisioningAttributes(updatedAttributes);
    }
    const clearValues=(index)=>{
        const updatedAttributes = [...provisioningAttributes];
        updatedAttributes[index].value = "";
        setProvisioningAttributes(updatedAttributes);
    }
    return (
        <div>
            <h5 className="fs-16 fw-bold text-black">Provisioning Attributes</h5>

            <Row>
                <Col xs={6} lg={3} sm={6}>
                    <LabelText
                        htmlFor={"name"}
                        className={"text-danger"}
                        displayText={
                            "Name"
                        }
                    />
                    <LabelText
                        htmlFor={"name"}
                        classLabelName={`d-block ms-0 rv-label-muted fw-normal`}
                        displayText={
                            `Default`
                        }
                    />
                </Col>
                <Col xs={6} lg={3} sm={6}>
                    <LabelText
                        htmlFor={"value"}
                        className={"text-danger"}
                        displayText={
                            "Value"
                        }
                    />
                    <LabelText
                        htmlFor={"value"}
                        classLabelName={`d-block ms-0 rv-label-muted fw-normal`}
                        displayText={
                            `Enter Value`
                        }
                    /></Col>
                <Col lg={2}></Col>
            </Row>
            <div className="overflow-y-auto-200">
                {provisioningAttributes.map((attribute, index) => (
                <Row className="my-2" key={index}>
                    <Col xs={6} lg={3} sm={6}>
                        <InputField
                            disabled={true}
                            name="name"
                            type="text"
                            className="form-control bg-transparent"
                            id="code"
                            value={attribute.name}
                            handleChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </Col>
                    <Col xs={6} lg={3} sm={6}>
                        <InputField
                            name="value"
                            type="text"
                            className="form-control"
                            id="value"
                            value={attribute.value}
                            handleChange={(e) => {
                                handleValueChange(index, e.target.value);
                                setFormData({ ...formData, value: e.target.value })
                            }}
                        />
                    </Col>
                    <Col xs={6} lg={3} sm={6} className="align-self-center">
                        <button type="button" className="border-0 bg-transparent" onClick={() => clearValues(index)}>
                            <i class="ri-close-line fw-bold align-middle fs-16 me-2 text-red"></i>
                        </button>

                    </Col>
                </Row>
            ))}
            </div>
            
        </div>


    )
}